export default "__VITE_ASSET__VcgtR9Rr__"